exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nil-sa-groups-timeslotcolumn-style__noAppointments{height:160px;width:100%;background-color:rgba(73,69,68,.2);border-radius:3px;padding-top:60px;margin-bottom:8px}", ""]);

// exports
exports.locals = {
	"noAppointments": "nil-sa-groups-timeslotcolumn-style__noAppointments"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/groups/TimeSlotColumn/style.less
// module id = 407
// module chunks = 0